import React from 'react';
import Style      from './style.sass';

const Button = ({onClick, type, text}) => {
  return (
    <button className={Style.Postal__button} onClick={onClick} type={type}>{ text }</button>
  )
}

export default Button;